'use client';
import { createContext, useContext, useState } from 'react';
import {
  HomepageHeroCarouselContent,
  HomepageHeroStrapiProps,
} from '../HomepageHeroStrapi';

const ModernLayoutContext = createContext({
  activeSlideIndex: 0,
  slides: [] as HomepageHeroCarouselContent[],
  handleSelectSlide: (index: number) => {},
});

export function ModernLayoutProvider({
  children,
  props,
}: {
  children: React.ReactNode;
  props: HomepageHeroStrapiProps;
}) {
  const [selectedSlideIndex, setSelectedSlideIndex] = useState<number>(0);

  return (
    <ModernLayoutContext.Provider
      value={{
        activeSlideIndex: selectedSlideIndex,
        handleSelectSlide: setSelectedSlideIndex,
        slides: props.carousel?.carouselContent || [],
      }}
    >
      {children}
    </ModernLayoutContext.Provider>
  );
}

export function useModernLayoutContext() {
  return useContext(ModernLayoutContext);
}

export default ModernLayoutContext;
